import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface CreateCareerOutcomeParams {
  userId: string;
  careerOutcomeStatus: string;
  learningPathId: number;
  context?: string;
}

const { useCreate: useCreateCareerOutcome } = getCRUDHooks({
  entityName: 'careerOutcomes',
  create: ({ userId, careerOutcomeStatus, learningPathId, context }: CreateCareerOutcomeParams) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .careerOutcomes.create(
        {
          careerOutcomeStatus,
          learningPathId,
        },
        false
      )
      .setHeader('X-Request-Context', context)
      .execute(),
});

// eslint-disable-next-line import/prefer-default-export
export { useCreateCareerOutcome };
